import { render } from "./OidoHelpIcon.vue?vue&type=template&id=c9ccdf00&scoped=true"
import script from "./OidoHelpIcon.vue?vue&type=script&lang=js"
export * from "./OidoHelpIcon.vue?vue&type=script&lang=js"

import "./OidoHelpIcon.vue?vue&type=style&index=0&id=c9ccdf00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9ccdf00"]])

export default __exports__